import { map, switchMap, tap } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { ComponentStore } from "@ngrx/component-store";
import { Observable, of } from "rxjs";
import { ComponentsStoreState, InitialStoreState } from "./components.model";
import { ChipsCategories, ChipsType } from "./configs/chips.config";

@Injectable({
  providedIn: "root",
})
export class ComponentsStore extends ComponentStore<ComponentsStoreState> {
  constructor() {
    super(InitialStoreState)
  }

   /*
   * Selectors read state out of our component store
   */
    readonly selectedChip$: Observable<string> = this.select(
      (state) => state.chipsCategories.selectedChip
    );

    readonly chipCategories$: Observable<ChipsCategories> = this.select(
      (state) => state.chipsCategories
    );

    readonly searchedGames$: Observable<string> = this.select(
      (state) => state.searchedGame
    );

   /*
   * Updaters act as reducers as such and add values to our component state
   */
    readonly addRemoveSelectedChip = this.updater((state, selectedChip: string) => ({
      ...state.chipsCategories, chipsCategories : {...state.chipsCategories, selectedChip }
    }));

    readonly addRemoveSelectedActiveChip = this.updater((state, chipsCategories: ChipsCategories) => ({
      ...state, chipsCategories: chipsCategories
    }));

    readonly addSearchedGames = this.updater((state, searchedGame: string) => ({
      ...state, searchedGame: searchedGame
    }));

    /*
   * Effects trigger side effects which manipulate the components state (we can also do this by calling .setState() in our component)
   * Effects are automatically subscribed to in the component they are called in for the life of the component
   */
    public switchChipSelection = this.effect((chipKeyActivated$: Observable<number>) => {
      return chipKeyActivated$.pipe(
        switchMap((chipKeyActivated: number) => {
          return this.chipCategories$.pipe(
            tap((chipsCategories: ChipsCategories) => {
              chipsCategories.chipCategories.forEach((category: ChipsType) => {
                category.active = false;
              })
              chipsCategories.chipCategories[chipKeyActivated].active = true;
              this.addRemoveSelectedActiveChip(chipsCategories);
            })
          )
        })
      );
    });

    public removeChipSelection = this.effect((removeChip$) => {
      return removeChip$.pipe(
          switchMap(() => {
            return this.chipCategories$.pipe(
              tap((chipsCategories: ChipsCategories) => {
                chipsCategories.chipCategories.forEach((category: ChipsType) => {
                  category.active = false;
                })
                this.addRemoveSelectedActiveChip(chipsCategories);
              }
            )
          );
        })
      )
    });
}

